import { Button, IconButton } from "@dropbox/dig-components/buttons";
import { Text } from "@dropbox/dig-components/typography";
import { Box, Stack } from "@dropbox/dig-foundations";
import { UIIcon } from "@dropbox/dig-icons";
import { CloseLine } from "@dropbox/dig-icons/dist/mjs/assets";
import { useMirageAnalyticsContext } from "@mirage/analytics/AnalyticsProvider";
import { PAP_Select_Upsell } from "@mirage/analytics/events/types/select_upsell";
import { PAP_Shown_Upsell } from "@mirage/analytics/events/types/shown_upsell";
import type { UIConnector } from "@mirage/shared/types";

import { useConnectorsUI } from "@mirage/mosaics/SettingsPage/useConnectorsUI";
import { useDoOnceOnMount } from "@mirage/shared/hooks/useDoOnceOnMount";
import i18n from "@mirage/translations";
import { useCallback } from "react";
import styles from "./AddAppsUpsellOnSerp.module.css";
import { AppsFacepile } from "./AppsFacepile";

export const AddAppsUpsellOnSerp = ({
  setDismissed,
  upsellConnectors: _upsellConnectors,
}: {
  setDismissed: () => void;
  upsellConnectors: UIConnector[];
}) => {
  const { reportPapEvent } = useMirageAnalyticsContext();
  const { openConnectors } = useConnectorsUI();
  const handleAddApps = useCallback(() => {
    openConnectors();
    reportPapEvent(
      PAP_Select_Upsell({
        featureLine: "search",
        actionSurface: "serp",
        upsellFeature: "dash_connectors",
        upsellFormat: "banner",
        ctaName: "add_dash_connectors",
      }),
    );
  }, [openConnectors, reportPapEvent]);

  const onDismiss = useCallback(() => {
    reportPapEvent(
      PAP_Select_Upsell({
        featureLine: "search",
        actionSurface: "serp",
        upsellFeature: "dash_connectors",
        upsellFormat: "banner",
        ctaName: "close",
      }),
    );
    setDismissed();
  }, [reportPapEvent]);

  useDoOnceOnMount(() => {
    reportPapEvent(
      PAP_Shown_Upsell({
        featureLine: "search",
        actionSurface: "serp",
        upsellFeature: "dash_connectors",
        upsellFormat: "banner",
      }),
    );
  });
  return (
    <Box className={styles.addAppsUpsellOnSerp}>
      <Stack display="flex" gap="Micro Small">
        <AppsFacepile />
        <Text isBold>{i18n.t("add_apps_search_banner_title")}</Text>
        <Text>{i18n.t("add_apps_search_banner_subtitle")}</Text>
      </Stack>

      <Box className={styles.ctaButtonContainer}>
        <Button
          variant="primary"
          className={styles.ctaButton}
          onClick={handleAddApps}
        >
          {i18n.t("add_apps")}
        </Button>

        <IconButton variant="transparent" onClick={onDismiss}>
          <UIIcon src={CloseLine} />
        </IconButton>
      </Box>
    </Box>
  );
};
